import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { style } from "./error-tile.css";
import "@phosphor-icons/webcomponents/PhArrowCircleUpRight";

@customElement("wow-error-tile")
export class WowErrorTile extends LitElement {
  static override styles = [style];

  @property({ type: String })
  handle!: string;

  @property({ type: String })
  image!: string;

  override render() {
    return html`
      <a href=${window.location.origin + "/" + this.handle} class="background">
        <div class="image">
          <img src=${this.image} alt="profile picture of ${this.handle}" />
        </div>
        <div class="handle">
          ${this.handle}
          <ph-arrow-circle-up-right size="16"></ph-arrow-circle-up-right>
        </div>
      </a>
    `;
  }
}
